/// <reference types="redux-persist/types" />
/// <reference types="vite-plugin-svgr/client" />
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";

import AppRouter from "@/routes/index";

import * as RadixTooltip from "@radix-ui/react-tooltip";

import { persistor, store } from "./store";

import { SsoProvider } from "./context/SsoProvider";
import { persistOptions, queryClient } from "./lib/react-query";

const basePath = import.meta.env.VITE_BASE_PATH || "/";
const router = createBrowserRouter([{ path: "*", Component: AppRouter }], {
  basename: basePath.endsWith("/") ? basePath.slice(0, -1) : basePath
});

const App = () => {
  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={persistOptions}
    >
      <SsoProvider>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <RadixTooltip.Provider>
              <RouterProvider router={router} />
            </RadixTooltip.Provider>
          </PersistGate>
        </Provider>
      </SsoProvider>
    </PersistQueryClientProvider>
  );
};

export default App;
